import {useCallback, useEffect, useState} from "react";

export function useFetchedResource<T>(get: () => Promise<T>) {
  const [resource, setResource] = useState<T | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchResource = useCallback(async (fetchSilently = false) => {
    if (!fetchSilently) {
      setLoading(true);
    }
    let fetchedResource = null
    try {
      fetchedResource = await get();
      setResource(fetchedResource);
    } catch (error) {
      // @ts-ignore
      setError(error);
    } finally {
      if (!fetchSilently) {
        setLoading(false);
      }
    }
    return fetchedResource
  }, []);

  return { resource, error, loading, reload: fetchResource };
}
